import * as React from 'react';
import { useGetCuttingQuery } from "../../../apis/Cutting.api";
import { PrimaryCutting, Cutting } from "../../../types/models/Cutting";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";

type IDisplayProps = {
    data: Cutting;
};

export const CuttingNameDisplay: React.FC<IDisplayProps> = ({data}) => {
    if (data) {
        return (<>{ data?.name }
                    </>)
    } else {
        return undefined
    }
}

type INameProps = {
    id: ID;

};

const CuttingName: React.FC<INameProps> = ({id}) => {
    const { data } = useGetCuttingQuery(PrimaryCutting.fromId(id))
    return (<CuttingNameDisplay data={data}/>)
}

export default CuttingName;
